import { ICreateRecipeFormData, ImageCreationType } from "./types";

interface PreparePayloadProps {
  data: ICreateRecipeFormData;
  createImage: ImageCreationType;
}

export const preparingPayload = async ({ data, createImage }:PreparePayloadProps) => {
  // collecting images, if will be some error, need do requlest and delete images
  let needToDeleteImages = [] as string[];

  try {
    const {
      images, // at ther end, all images coming inside that varaible
      instructions,
      uploadedFiles,
      existingImages: sinlgeExisImage,
      ingredientsListIds,
      ...restAllFormData
    } = data

    const exisArray = sinlgeExisImage?.map((i) => i.id) || []
    let overwritedImage = exisArray as string[];

    // ### ### ### ### ### ### ### ### ### ### ### ### ### ### SINGLE IMAGE
    if (uploadedFiles instanceof FileList) {
      const formData = new FormData();

      formData.append('files[]', uploadedFiles[0]);

      const { id } = await createImage(formData).unwrap()

      if (id) {
        overwritedImage = [id]
        needToDeleteImages = [...needToDeleteImages, id]
      }
    }

    // ### ### ### ### ### ### ### ### ### ### ### ### ### ### MULTIPLE IMAGE
    const newInstructions = instructions?.map(async ({
      existingImages: multiExistingImages,
      uploadedFiles: instUploadedFiles,
      ...restOfInst
    }) => {
      const newUploadedImages = (instUploadedFiles?.length ? Array.from(instUploadedFiles) : [])
        ?.map(async (img) => {
          let uploadedImageId = ''

          if (img instanceof File) {
            const formData = new FormData();

            formData.append('files[]', img);

            const { id } = await createImage(formData).unwrap()

            if (id) {
              uploadedImageId = id
            }
          }

          return uploadedImageId
        })
        .filter((i) => i)

      const newUploadedInstImages = await Promise.all(newUploadedImages)
      const existingInstImages = multiExistingImages.map((i) => i.id)

      needToDeleteImages = [
        ...needToDeleteImages,
        ...newUploadedInstImages,
        ...existingInstImages
      ]

      return {
        ...restOfInst,
        images: [...newUploadedInstImages, ...existingInstImages]
      }
    })

    const instructionsWithImages = await Promise.all(newInstructions)

    const result = {
      ...restAllFormData,
      images: overwritedImage,
      ingredientsList: ingredientsListIds,
      instructions: instructionsWithImages
    }

    return {
      result,
      needToDeleteImages
    }
  } catch (error: any) {
    throw needToDeleteImages
  }
};
